import React, { useState, useEffect } from "react";
import EditSalaryLayouts from "../../components/EditSalaryLayout.jsx";
import { GiTakeMyMoney } from "react-icons/gi";
import {
  Row,
  Col,
  Button,
  Modal,
  Pagination,
  Dropdown,
  ButtonGroup,
  Form,
} from "react-bootstrap";
import { FaEye } from "react-icons/fa";
import { HiDocumentText } from "react-icons/hi2";
import { Link } from "react-router-dom";
import "./basic-salary.css";

export default function BasicSalary() {
  const rowsPerPage = 10;
  const [currentPage, setCurrentPage] = useState(1);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [modalData, setModalData] = useState({});
  const [searchQuery, setSearchQuery] = useState(""); // State for search query

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const response = await fetch(
          "https://backend.ems.uk.hiradentallab.com/api/user/getAllUsers"
        );
        const result = await response.json();

        // Filter out inactive users and then map the data
        const filteredData = result
          .filter((user) => user.status === "active") // Filter only active users
          .map((user) => ({
            id: user.userId,
            name: user.name,
            role: user.role,
            amount: `${user.basicSalary}`,
          }));

        setData(filteredData);  // Set the state with filtered data
      } catch (error) {
        console.error("Error fetching data:", error);
      }
      setLoading(false);
    };

    fetchData();
  }, []);


  const handleShowModal = (data) => {
    setModalData(data);
    setShowModal(true);
  };

  const handleCloseModal = () => setShowModal(false);

  const handlePageChange = (pageNumber) => {
    if (pageNumber >= 1 && pageNumber <= Math.ceil(data.length / rowsPerPage)) {
      setCurrentPage(pageNumber);
    }
  };

  const pageRange = () => {
    const pages = [];
    const totalPages = Math.ceil(data.length / rowsPerPage);
    let startPage = Math.max(currentPage - 1, 1);
    let endPage = Math.min(startPage + 2, totalPages);

    if (endPage - startPage < 2) {
      startPage = Math.max(endPage - 2, 1);
    }

    for (let i = startPage; i <= endPage; i++) {
      pages.push(i);
    }
    return pages;
  };

  // Search handler
  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
    setCurrentPage(1); // Reset to first page on new search
  };

  const filteredData = data.filter((item) =>
    item.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
    item.role.toLowerCase().includes(searchQuery.toLowerCase()) ||
    item.amount.includes(searchQuery)
  );

  const handleSubmit = (event) => {
    event.preventDefault(); // Prevent form submission reload
  };

  return (
    <EditSalaryLayouts>
      <h1 className="basic-salary-title">
        <GiTakeMyMoney /> Basic Salary
      </h1>
      <hr />
      <div className="basic-salary-container">
        <div className="emp-info-actions">
          <Row>
            <Col xs={12} md={6} className="d-flex align-items-center mb-2">
              <Dropdown as={ButtonGroup}>
                <Button variant="primary">Show Entries</Button>
                <Dropdown.Toggle
                  split
                  variant="primary"
                  id="dropdown-split-basic"
                />
                <Dropdown.Menu>
                  <Dropdown.Item>10</Dropdown.Item>
                  <Dropdown.Item>25</Dropdown.Item>
                  <Dropdown.Item>50</Dropdown.Item>
                  <Dropdown.Item>100</Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </Col>
            <Col xs={12} md={6} className="d-flex justify-content-end mb-2">
              <div className="search-container">
                <Form className="d-flex" onSubmit={handleSubmit}>
                  <Form.Control
                    type="search"
                    placeholder="Search by name, role, or amount"
                    aria-label="Search"
                    className="holiday-search"
                    value={searchQuery} // Bind search input value
                    onChange={handleSearchChange} // Update search query on change
                  />
                </Form>
              </div>
            </Col>
          </Row>
        </div>

        {loading ? (
          <p>Loading...</p>
        ) : (
          <table className="table table-striped table-style">
            <thead className="basic-salary-table-header">
              <tr className="table-header">
                <th>SR</th>
                <th>Name</th>
                <th>Role</th>
                <th>Amount</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {filteredData
                .slice(
                  (currentPage - 1) * rowsPerPage,
                  currentPage * rowsPerPage
                )
                .map((item, index) => (
                  <tr key={item.id} style={{ textAlign: "center" }}>
                    <td>{(currentPage - 1) * rowsPerPage + index + 1}</td>
                    <td>{item.name}</td>
                    <td>{item.role}</td>
                    <td>{item.amount}</td>
                    <td>
                      <Button
                      variant="primary"
                      size="sm"
                      style={{marginRight:'5px'}}
                        onClick={() => handleShowModal(item)}
                      >
                        <FaEye />
                      </Button>
                      <Link to={`/edit-salary/${item.id}`}>
                        <Button
                        variant="warning"
                        size="sm">
                          <HiDocumentText />
                        </Button>
                      </Link>
                    </td>
                  </tr>
                ))}
            </tbody>
            <tfoot className="table-footer">
                <tr className="holiday-table-footer">
                <td>Total</td>
                <td>{filteredData.length}</td>
                <td colSpan="3"></td>
              </tr>
            </tfoot>
          </table>
        )}

        {/* Pagination */}
        <div className="pagination-row">
            <div className="entries-info">
              Showing {(currentPage - 1) * rowsPerPage + 1} to{" "}
              {Math.min(currentPage * rowsPerPage, data.length)} of{" "}
              {data.length} entries
            </div>
            <nav>
              <ul className="pagination no-gap">
                <li
                  className={`page-item ${currentPage === 1 ? "disabled" : ""}`}
                >
                  <a
                    href="/#"
                    className="page-link"
                    onClick={(e) => {
                      e.preventDefault();
                      handlePageChange(currentPage - 1);
                    }}
                  >
                    Previous
                  </a>
                </li>
                {pageRange().map((pageNumber) => (
                  <li
                    key={pageNumber}
                    className={`page-item ${
                      currentPage === pageNumber ? "active" : ""
                    }`}
                  >
                    <a
                      href="/#"
                      className="page-link"
                      onClick={(e) => {
                        e.preventDefault();
                        handlePageChange(pageNumber);
                      }}
                    >
                      {pageNumber}
                    </a>
                  </li>
                ))}
                <li
                  className={`page-item ${
                    currentPage === Math.ceil(data.length / rowsPerPage)
                      ? "disabled"
                      : ""
                  }`}
                >
                  <a
                    href="/#"
                    className="page-link"
                    onClick={(e) => {
                      e.preventDefault();
                      handlePageChange(currentPage + 1);
                    }}
                  >
                    Next
                  </a>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      <Modal show={showModal} onHide={handleCloseModal}>
        <Modal.Header closeButton>
          <Modal.Title>Employee Salary Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>
            <strong>Name:</strong> {modalData.name}
          </p>
          <p>
            <strong>Role:</strong> {modalData.role}
          </p>
          <p>
            <strong>Amount:</strong> {modalData.amount}
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={handleCloseModal}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </EditSalaryLayouts>
  );
}